import { Box, CircularProgress, Typography } from "@mui/material";
import React, { useCallback, useContext, useEffect, useState } from "react";
import { APIRoutes } from "../../../../utils/constants";
import { UserContext } from "../..";
import { toast } from "react-toastify";
import TeamWithPlayer from "./TeamWithPlayers";
import HttpService from "../../../../hooks/Https-services";

const ChannelCards = () => {
  const [playerData, setPlayerData] = useState([]);
  const { selectedTeam, setSelectedPlayer, selectedPlayer }: any =
    useContext(UserContext);
  const [isSkeleton, setIsSkeleton] = useState(true);
  const GetPlayesNameByTeamsName = useCallback(async () => {
    try {
      if (!selectedTeam?.length) {
        setIsSkeleton(false);
        setPlayerData([]);
        setSelectedPlayer([]);
        return;
      }
      const req = await HttpService.getS(
        `${APIRoutes.GetAllPlayersHTP}?team_ids=${selectedTeam.join(
          ","
        )}&limit=10`
      );
      if (req) {
        const data = req?.data?.data;
        setPlayerData(data);
        const findDuplicatePlayer = data.map((el: any) =>
          el?.players?.filter((ele: any) =>
            selectedPlayer
              ?.includes(ele.player_id)
              ?.map((ele: any) => ele.player_id)
          )
        );
        const submitArray = [].concat(...findDuplicatePlayer);
        setSelectedPlayer(submitArray);
        setIsSkeleton(false);
      }
      setIsSkeleton(false);
    } catch (error) {
      setIsSkeleton(false);
    }
  }, [selectedTeam]);

  useEffect(() => {
    GetPlayesNameByTeamsName();
  }, [GetPlayesNameByTeamsName]);

  return (
    <>
      {isSkeleton ? (
        <Box
          sx={{ display: "flex", justifyContent: "center", py: 10, width: 1 }}
        >
          <CircularProgress
            size={48}
            sx={{
              color: "#bf311a",
            }}
          />
        </Box>
      ) : (
        <>
          {playerData?.length == 0 ? (
            <Typography sx={{ my: 2 }}>Please Select Team</Typography>
          ) : (
            playerData.map((player: any) => <TeamWithPlayer player={player} />)
          )}
        </>
      )}
    </>
  );
};

export default ChannelCards;
